// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Atom_Box = require("./Atom_Box.bs.js");
var Atom_Text = require("./Atom_Text.bs.js");
var Atom_Cta_Ds = require("./Atom_Cta_Ds.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Atom_Cta_Css = require("./Atom_Cta_Css.bs.js");
var Atom_Text_Ds = require("./Atom_Text_Ds.bs.js");
var Particle_Color = require("../particle/Particle_Color.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Accessibility = require("../particle/Particle_Accessibility.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");
var Particle_Accessibility_Constant = require("../particle/Particle_Accessibility_Constant.bs.js");

function Atom_Cta$Internal(Props) {
  var accessibility = Props.accessibility;
  var children = Props.children;
  var ctaRef = Props.ctaRef;
  var dataAnchor = Props.dataAnchor;
  var directionOpt = Props.direction;
  var display = Props.display;
  var displayOrder = Props.displayOrder;
  var id = Props.id;
  var identifier = Props.identifier;
  var innerSpace = Props.innerSpace;
  var kind = Props.kind;
  var label = Props.label;
  var labelId = Props.labelId;
  var labelKindOpt = Props.labelKind;
  var onBlur = Props.onBlur;
  var onFocus = Props.onFocus;
  var rules = Props.rules;
  var screenReadersLabel = Props.screenReadersLabel;
  var style = Props.style;
  var direction = directionOpt !== undefined ? Caml_option.valFromOption(directionOpt) : Particle_Screen_Constants.flexDirectionRow;
  var labelKind = labelKindOpt !== undefined ? labelKindOpt : "span";
  var cta = Atom_Cta_Ds.make(style);
  var match = Atom_Cta_Ds.view(cta);
  var textStyle = match.textStyle;
  var styleRules = Atom_Cta_Css.toCss(cta);
  var match$1 = Atom_Text_Ds.view(textStyle);
  var textColorRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.color(Particle_Color.Css.color(match$1.color))]);
  var rules$1 = Particle_Screen_Ds.$$Array.concat(Particle_Screen_Ds.$$Array.concatOrDefault(styleRules, rules), textColorRules);
  var match$2 = screenReadersLabel !== undefined ? [
      Particle_Accessibility_Constant.ariaHidden,
      React.createElement(Atom_Text.ScreenreadersLabel.make, {
            children: screenReadersLabel
          })
    ] : [
      undefined,
      null
    ];
  var child;
  if (children !== undefined) {
    child = Caml_option.valFromOption(children);
  } else {
    var justifyContent = Belt_Option.map(Belt_Option.flatMap(match.block, (function (param) {
                return param.justifyContent;
              })), (function (justifyContent) {
            return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, justifyContent);
          }));
    var tmp = {
      children: Belt_Option.mapWithDefault(label, null, (function (prim) {
              return prim;
            })),
      kind: labelKind,
      style: textStyle,
      width: Particle_Screen_Constants.oneHundredPctWidth
    };
    var tmp$1 = match$2[0];
    if (tmp$1 !== undefined) {
      tmp.accessibility = Caml_option.valFromOption(tmp$1);
    }
    if (labelId !== undefined) {
      tmp.id = Caml_option.valFromOption(labelId);
    }
    if (justifyContent !== undefined) {
      tmp.justifyContent = Caml_option.valFromOption(justifyContent);
    }
    child = React.createElement(Atom_Text.make, tmp);
  }
  var tmp$2 = {
    alignItems: Particle_Screen_Constants.alignItemsCenter,
    background: match.background,
    children: null,
    direction: direction,
    rules: rules$1,
    spacer: match.spacer
  };
  if (accessibility !== undefined) {
    tmp$2.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (match.border !== undefined) {
    tmp$2.border = Caml_option.valFromOption(match.border);
  }
  if (dataAnchor !== undefined) {
    tmp$2.dataAnchor = dataAnchor;
  }
  if (display !== undefined) {
    tmp$2.display = Caml_option.valFromOption(display);
  }
  if (displayOrder !== undefined) {
    tmp$2.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (id !== undefined) {
    tmp$2.id = id;
  }
  if (identifier !== undefined) {
    tmp$2.identifier = identifier;
  }
  if (kind !== undefined) {
    tmp$2.kind = Caml_option.valFromOption(kind);
  }
  if (onBlur !== undefined) {
    tmp$2.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp$2.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (innerSpace !== undefined) {
    tmp$2.innerSpace = Caml_option.valFromOption(innerSpace);
  }
  if (ctaRef !== undefined) {
    tmp$2.ref_ = Caml_option.valFromOption(ctaRef);
  }
  return React.createElement(Atom_Box.make, tmp$2, match$2[1], child);
}

Atom_Cta$Internal.displayName = "Cta_Internal";

function getBoxKind(disabled, type_, onClick, title) {
  var handleClick = function (ev) {
    if (onClick !== undefined) {
      return Curry._1(onClick, ev);
    }
    
  };
  if (disabled !== undefined && disabled) {
    return {
            TAG: /* ButtonDisabled */2,
            _0: Belt_Option.getWithDefault(type_, "button")
          };
  } else {
    return {
            TAG: /* Button */1,
            _0: Belt_Option.getWithDefault(type_, "button"),
            _1: handleClick,
            _2: title
          };
  }
}

function Atom_Cta$Button$Block(Props) {
  var accessibility = Props.accessibility;
  var children = Props.children;
  var ctaRef = Props.ctaRef;
  var dataAnchor = Props.dataAnchor;
  var disabled = Props.disabled;
  var display = Props.display;
  var displayOrder = Props.displayOrder;
  var direction = Props.direction;
  var id = Props.id;
  var identifier = Props.identifier;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onFocus = Props.onFocus;
  var screenReadersLabel = Props.screenReadersLabel;
  var style = Props.style;
  var type_ = Props.type_;
  var title = Props.title;
  var boxKind = getBoxKind(disabled, type_, onClick, title);
  var tmp = {
    children: children,
    kind: boxKind,
    style: style
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (ctaRef !== undefined) {
    tmp.ctaRef = Caml_option.valFromOption(ctaRef);
  }
  if (dataAnchor !== undefined) {
    tmp.dataAnchor = Caml_option.valFromOption(dataAnchor);
  }
  if (direction !== undefined) {
    tmp.direction = Caml_option.valFromOption(direction);
  }
  if (display !== undefined) {
    tmp.display = Caml_option.valFromOption(display);
  }
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (screenReadersLabel !== undefined) {
    tmp.screenReadersLabel = Caml_option.valFromOption(screenReadersLabel);
  }
  return React.createElement(Atom_Cta$Internal, tmp);
}

var Block = {
  make: Atom_Cta$Button$Block
};

function Atom_Cta$Button(Props) {
  var accessibility = Props.accessibility;
  var ctaRef = Props.ctaRef;
  var dataAnchor = Props.dataAnchor;
  var disabled = Props.disabled;
  var display = Props.display;
  var displayOrder = Props.displayOrder;
  var id = Props.id;
  var identifier = Props.identifier;
  var label = Props.label;
  var labelKind = Props.labelKind;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onFocus = Props.onFocus;
  var screenReadersLabel = Props.screenReadersLabel;
  var style = Props.style;
  var type_ = Props.type_;
  var title = Props.title;
  var rules = Props.rules;
  var boxKind = getBoxKind(disabled, type_, onClick, title);
  var tmp = {
    kind: boxKind,
    style: style
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (ctaRef !== undefined) {
    tmp.ctaRef = Caml_option.valFromOption(ctaRef);
  }
  if (dataAnchor !== undefined) {
    tmp.dataAnchor = Caml_option.valFromOption(dataAnchor);
  }
  if (display !== undefined) {
    tmp.display = Caml_option.valFromOption(display);
  }
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  if (label !== undefined) {
    tmp.label = label;
  }
  if (labelKind !== undefined) {
    tmp.labelKind = Caml_option.valFromOption(labelKind);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (rules !== undefined) {
    tmp.rules = Caml_option.valFromOption(rules);
  }
  if (screenReadersLabel !== undefined) {
    tmp.screenReadersLabel = Caml_option.valFromOption(screenReadersLabel);
  }
  return React.createElement(Atom_Cta$Internal, tmp);
}

Atom_Cta$Button.displayName = "Button";

function getBoxLink(href, target, title, onClick, rel) {
  return {
          TAG: /* Link */9,
          _0: href,
          _1: target,
          _2: title,
          _3: onClick,
          _4: rel
        };
}

function Atom_Cta$Link$Block(Props) {
  var accessibility = Props.accessibility;
  var children = Props.children;
  var ctaRef = Props.ctaRef;
  var dataAnchor = Props.dataAnchor;
  var direction = Props.direction;
  var href = Props.href;
  var identifier = Props.identifier;
  var innerSpace = Props.innerSpace;
  var onClick = Props.onClick;
  var screenReadersLabel = Props.screenReadersLabel;
  var style = Props.style;
  var targetOpt = Props.target;
  var target = targetOpt !== undefined ? targetOpt : "Self";
  var boxLink = getBoxLink(href, target, undefined, onClick, undefined);
  var tmp = {
    children: children,
    kind: boxLink,
    style: style
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (ctaRef !== undefined) {
    tmp.ctaRef = Caml_option.valFromOption(ctaRef);
  }
  if (dataAnchor !== undefined) {
    tmp.dataAnchor = Caml_option.valFromOption(dataAnchor);
  }
  if (direction !== undefined) {
    tmp.direction = Caml_option.valFromOption(direction);
  }
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  if (innerSpace !== undefined) {
    tmp.innerSpace = Caml_option.valFromOption(innerSpace);
  }
  if (screenReadersLabel !== undefined) {
    tmp.screenReadersLabel = Caml_option.valFromOption(screenReadersLabel);
  }
  return React.createElement(Atom_Cta$Internal, tmp);
}

var Block$1 = {
  make: Atom_Cta$Link$Block
};

function Atom_Cta$Link$Responsive(Props) {
  var accessibility = Props.accessibility;
  var ctaRef = Props.ctaRef;
  var dataAnchor = Props.dataAnchor;
  var displayOrder = Props.displayOrder;
  var href = Props.href;
  var id = Props.id;
  var identifier = Props.identifier;
  var labelId = Props.labelId;
  var labels = Props.labels;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onFocus = Props.onFocus;
  var screenReadersLabel = Props.screenReadersLabel;
  var style = Props.style;
  var targetOpt = Props.target;
  var title = Props.title;
  var target = targetOpt !== undefined ? targetOpt : "Self";
  var boxLink = getBoxLink(href, target, title, onClick, undefined);
  var cta = Atom_Cta_Ds.make(style);
  var match = Atom_Cta_Ds.view(cta);
  var rules = Atom_Cta_Css.toCss(cta);
  var match$1 = screenReadersLabel !== undefined ? [
      Particle_Accessibility_Constant.ariaHidden,
      React.createElement(Atom_Text.ScreenreadersLabel.make, {
            children: screenReadersLabel
          })
    ] : [
      undefined,
      null
    ];
  var tmp = {
    style: match.textStyle,
    labels: labels
  };
  var tmp$1 = match$1[0];
  if (tmp$1 !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(tmp$1);
  }
  if (labelId !== undefined) {
    tmp.id = Caml_option.valFromOption(labelId);
  }
  var children = React.createElement(React.Fragment, undefined, match$1[1], React.createElement(Atom_Text.Responsive.make, tmp));
  var tmp$2 = {
    alignItems: Particle_Screen_Constants.alignItemsCenter,
    background: match.background,
    children: children,
    direction: Particle_Screen_Constants.flexDirectionRow,
    kind: boxLink,
    rules: rules,
    spacer: match.spacer
  };
  if (accessibility !== undefined) {
    tmp$2.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (match.border !== undefined) {
    tmp$2.border = Caml_option.valFromOption(match.border);
  }
  if (dataAnchor !== undefined) {
    tmp$2.dataAnchor = dataAnchor;
  }
  if (displayOrder !== undefined) {
    tmp$2.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (id !== undefined) {
    tmp$2.id = id;
  }
  if (identifier !== undefined) {
    tmp$2.identifier = identifier;
  }
  if (onBlur !== undefined) {
    tmp$2.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp$2.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (ctaRef !== undefined) {
    tmp$2.ref_ = Caml_option.valFromOption(ctaRef);
  }
  return React.createElement(Atom_Box.make, tmp$2);
}

var Responsive = {
  make: Atom_Cta$Link$Responsive
};

function Atom_Cta$Link(Props) {
  var accessibility = Props.accessibility;
  var ctaRef = Props.ctaRef;
  var dataAnchor = Props.dataAnchor;
  var displayOrder = Props.displayOrder;
  var href = Props.href;
  var id = Props.id;
  var identifier = Props.identifier;
  var label = Props.label;
  var labelId = Props.labelId;
  var labelKind = Props.labelKind;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onFocus = Props.onFocus;
  var rel = Props.rel;
  var screenReadersLabel = Props.screenReadersLabel;
  var style = Props.style;
  var targetOpt = Props.target;
  var title = Props.title;
  var target = targetOpt !== undefined ? targetOpt : "Self";
  var boxLink = getBoxLink(href, target, title, onClick, rel);
  var tmp = {
    kind: boxLink,
    style: style
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (ctaRef !== undefined) {
    tmp.ctaRef = Caml_option.valFromOption(ctaRef);
  }
  if (dataAnchor !== undefined) {
    tmp.dataAnchor = Caml_option.valFromOption(dataAnchor);
  }
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  if (label !== undefined) {
    tmp.label = label;
  }
  if (labelId !== undefined) {
    tmp.labelId = Caml_option.valFromOption(labelId);
  }
  if (labelKind !== undefined) {
    tmp.labelKind = Caml_option.valFromOption(labelKind);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (screenReadersLabel !== undefined) {
    tmp.screenReadersLabel = Caml_option.valFromOption(screenReadersLabel);
  }
  return React.createElement(Atom_Cta$Internal, tmp);
}

function Atom_Cta$DownloadLink(Props) {
  var href = Props.href;
  var label = Props.label;
  var downloadOpt = Props.download;
  var style = Props.style;
  var accessibility = Props.accessibility;
  var download = downloadOpt !== undefined ? downloadOpt : "Default";
  return React.createElement(Atom_Cta$Internal, {
              accessibility: accessibility,
              kind: {
                TAG: /* DownloadLink */5,
                _0: href,
                _1: download
              },
              label: label,
              style: style
            });
}

function Atom_Cta$Seo(Props) {
  var href = Props.href;
  var label = Props.label;
  return React.createElement(Atom_Cta$Internal, {
              accessibility: Particle_Accessibility.notFocusable,
              kind: {
                TAG: /* Link */9,
                _0: href,
                _1: "Self",
                _2: undefined,
                _3: undefined,
                _4: undefined
              },
              label: label,
              style: /* Seo */22
            });
}

var Seo = {
  make: Atom_Cta$Seo
};

Atom_Cta$Link$Block.displayName = "Link.Block";

Atom_Cta$Link.displayName = "Link";

function Atom_Cta$Player(Props) {
  var label = Props.label;
  var onClick = Props.onClick;
  var ariaLabel = Props.ariaLabel;
  var accessibility = Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, ariaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  var tmp = {
    accessibility: accessibility,
    label: label,
    style: {
      TAG: /* Player */15,
      _0: /* Cta */0
    }
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement(Atom_Cta$Button, tmp);
}

var Player = {
  make: Atom_Cta$Player
};

function Atom_Cta$Mona$Button$Internal(Props) {
  var disabled = Props.disabled;
  var label = Props.label;
  var onClick = Props.onClick;
  var style = Props.style;
  var type_ = Props.type_;
  var tmp = {
    label: label,
    style: style
  };
  if (disabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(disabled);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (type_ !== undefined) {
    tmp.type_ = Caml_option.valFromOption(type_);
  }
  return React.createElement(Atom_Cta$Button, tmp);
}

var Internal = {
  make: Atom_Cta$Mona$Button$Internal
};

function Atom_Cta$Mona$Button(Props) {
  var disabled = Props.disabled;
  var label = Props.label;
  var onClick = Props.onClick;
  var variantOpt = Props.variant;
  var type_ = Props.type_;
  var variant = variantOpt !== undefined ? variantOpt : "base";
  var dsStyle = variant === "link" ? ({
        TAG: /* Mona */12,
        _0: /* ButtonWithLinkStyle */3
      }) : (
      variant === "outline" ? ({
            TAG: /* Mona */12,
            _0: {
              TAG: /* Outline */0,
              _0: Belt_Option.getWithDefault(disabled, false)
            }
          }) : (
          variant === "dropdown" ? ({
                TAG: /* Mona */12,
                _0: /* Dropdown */4
              }) : (
              disabled !== undefined && disabled ? ({
                    TAG: /* Mona */12,
                    _0: /* Disabled */5
                  }) : ({
                    TAG: /* Mona */12,
                    _0: /* Base */0
                  })
            )
        )
    );
  var tmp = {
    label: label,
    style: dsStyle
  };
  if (disabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(disabled);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (type_ !== undefined) {
    tmp.type_ = Caml_option.valFromOption(type_);
  }
  return React.createElement(Atom_Cta$Mona$Button$Internal, tmp);
}

var Button = {
  Internal: Internal,
  make: Atom_Cta$Mona$Button
};

function Atom_Cta$Mona$Link$Internal(Props) {
  var label = Props.label;
  var onClick = Props.onClick;
  var href = Props.href;
  var targetOpt = Props.target;
  var style = Props.style;
  var target = targetOpt !== undefined ? targetOpt : "Self";
  var tmp = {
    href: href,
    label: label,
    style: style,
    target: target
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement(Atom_Cta$Link, tmp);
}

var Internal$1 = {
  make: Atom_Cta$Mona$Link$Internal
};

function Atom_Cta$Mona$Link(Props) {
  var label = Props.label;
  var onClick = Props.onClick;
  var href = Props.href;
  var targetOpt = Props.target;
  var variantOpt = Props.variant;
  var target = targetOpt !== undefined ? targetOpt : "Self";
  var variant = variantOpt !== undefined ? variantOpt : "link";
  var dsStyle = variant === "outline" ? ({
        TAG: /* Mona */12,
        _0: {
          TAG: /* Outline */0,
          _0: false
        }
      }) : (
      variant === "eventLink" ? ({
            TAG: /* Mona */12,
            _0: /* EventLink */6
          }) : (
          variant === "footer" ? ({
                TAG: /* Mona */12,
                _0: /* FooterLink */2
              }) : ({
                TAG: /* Mona */12,
                _0: /* Link */1
              })
        )
    );
  var tmp = {
    label: label,
    href: href,
    target: target,
    style: dsStyle
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement(Atom_Cta$Mona$Link$Internal, tmp);
}

var Link = {
  Internal: Internal$1,
  make: Atom_Cta$Mona$Link
};

var Mona = {
  Button: Button,
  Link: Link
};

function Atom_Cta$Corporate(Props) {
  var variantOpt = Props.variant;
  var onClick = Props.onClick;
  var label = Props.label;
  var variant = variantOpt !== undefined ? variantOpt : "active";
  var dsStyle = {
    TAG: /* Corporate */3,
    _0: {
      TAG: /* ToggleButton */0,
      _0: variant
    }
  };
  var tmp = {
    label: label,
    style: dsStyle
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement(Atom_Cta$Button, tmp);
}

var Corporate = {
  make: Atom_Cta$Corporate
};

function Atom_Cta$AndroidReleases(Props) {
  var label = Props.label;
  var href = Props.href;
  var variant = Props.variant;
  if (typeof variant !== "object") {
    return React.createElement(Atom_Cta$Link, {
                href: href,
                label: label,
                style: {
                  TAG: /* AndroidReleases */0,
                  _0: /* Tutorial */0
                }
              });
  }
  var download = variant.VAL;
  var dsStyle = {
    TAG: /* AndroidReleases */0,
    _0: /* Download */1
  };
  var accessibility = Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  if (download !== undefined) {
    return React.createElement(Atom_Cta$DownloadLink, {
                href: href,
                label: label,
                download: download,
                style: dsStyle,
                accessibility: accessibility
              });
  } else {
    return React.createElement(Atom_Cta$DownloadLink, {
                href: href,
                label: label,
                style: dsStyle,
                accessibility: accessibility
              });
  }
}

var AndroidReleases = {
  make: Atom_Cta$AndroidReleases
};

function Atom_Cta$Presse$Button$Internal(Props) {
  var disabled = Props.disabled;
  var label = Props.label;
  var onClick = Props.onClick;
  var style = Props.style;
  var type_ = Props.type_;
  var tmp = {
    label: label,
    style: style
  };
  if (disabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(disabled);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (type_ !== undefined) {
    tmp.type_ = Caml_option.valFromOption(type_);
  }
  return React.createElement(Atom_Cta$Button, tmp);
}

var Internal$2 = {
  make: Atom_Cta$Presse$Button$Internal
};

function Atom_Cta$Presse$Button(Props) {
  var disabled = Props.disabled;
  var label = Props.label;
  var onClick = Props.onClick;
  var variantOpt = Props.variant;
  var type_ = Props.type_;
  var variant = variantOpt !== undefined ? variantOpt : "base";
  var dsStyle = variant === "outline" ? ({
        TAG: /* Presse */16,
        _0: {
          TAG: /* Outline */3,
          _0: Belt_Option.getWithDefault(disabled, false)
        }
      }) : (
      disabled !== undefined && disabled ? ({
            TAG: /* Presse */16,
            _0: /* Disabled */1
          }) : ({
            TAG: /* Presse */16,
            _0: /* Base */0
          })
    );
  var tmp = {
    label: label,
    style: dsStyle
  };
  if (disabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(disabled);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (type_ !== undefined) {
    tmp.type_ = Caml_option.valFromOption(type_);
  }
  return React.createElement(Atom_Cta$Presse$Button$Internal, tmp);
}

var Button$1 = {
  Internal: Internal$2,
  make: Atom_Cta$Presse$Button
};

var Presse = {
  Button: Button$1
};

var Button$2 = {
  Block: Block,
  make: Atom_Cta$Button
};

var Link$1 = {
  Block: Block$1,
  Responsive: Responsive,
  make: Atom_Cta$Link
};

exports.Button = Button$2;
exports.Link = Link$1;
exports.Seo = Seo;
exports.Player = Player;
exports.Mona = Mona;
exports.Corporate = Corporate;
exports.AndroidReleases = AndroidReleases;
exports.Presse = Presse;
/*  Not a pure module */
